import React from 'react';
import './LoadingSkeleton.css';

// Generic skeleton line
function SkeletonLine({ width, height = 16, style }) {
  return <div className="skeleton-line" style={{ width: width || '100%', height, ...style }} />;
}

// Card skeleton
function SkeletonCard({ lines = 3 }) {
  return (
    <div className="skeleton-card">
      <SkeletonLine width="60%" height={20} />
      {Array.from({ length: lines - 1 }).map((_, i) => (
        <SkeletonLine key={i} width={i === lines - 2 ? '40%' : '85%'} style={{ marginTop: 12 }} />
      ))}
    </div>
  );
}

// Table row skeleton
function SkeletonRow({ columns = 5 }) {
  return (
    <div className="skeleton-row">
      {Array.from({ length: columns }).map((_, i) => (
        <SkeletonLine key={i} width={i === 0 ? '70%' : '50%'} />
      ))}
    </div>
  );
}

// Full table skeleton
function SkeletonTable({ rows = 5, columns = 5 }) {
  return (
    <div className="skeleton-table">
      <div className="skeleton-row skeleton-header-row">
        {Array.from({ length: columns }).map((_, i) => (
          <SkeletonLine key={i} width="60%" height={12} />
        ))}
      </div>
      {Array.from({ length: rows }).map((_, i) => (
        <SkeletonRow key={i} columns={columns} />
      ))}
    </div>
  );
}

// List skeleton (cards)
function SkeletonList({ count = 4, lines = 3 }) {
  return (
    <div className="skeleton-list">
      {Array.from({ length: count }).map((_, i) => (
        <SkeletonCard key={i} lines={lines} />
      ))}
    </div>
  );
}

// Grid skeleton (for rewards/campaigns cards)
function SkeletonGrid({ count = 6 }) {
  return (
    <div className="skeleton-grid">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="skeleton-grid-card">
          <div className="skeleton-img" />
          <SkeletonLine width="70%" height={18} style={{ marginTop: 12 }} />
          <SkeletonLine width="50%" style={{ marginTop: 8 }} />
          <SkeletonLine width="30%" style={{ marginTop: 12 }} />
        </div>
      ))}
    </div>
  );
}

// Post feed skeleton
function SkeletonFeed({ count = 3 }) {
  return (
    <div className="skeleton-list">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="skeleton-card skeleton-feed-item">
          <div className="skeleton-feed-header">
            <div className="skeleton-avatar-small" />
            <div style={{ flex: 1 }}>
              <SkeletonLine width="40%" height={14} />
              <SkeletonLine width="20%" height={12} style={{ marginTop: 6 }} />
            </div>
          </div>
          <SkeletonLine width="90%" style={{ marginTop: 16 }} />
          <SkeletonLine width="70%" style={{ marginTop: 8 }} />
          <div className="skeleton-feed-actions" style={{ marginTop: 16 }}>
            <SkeletonLine width={60} height={20} />
            <SkeletonLine width={60} height={20} />
          </div>
        </div>
      ))}
    </div>
  );
}

export { SkeletonLine, SkeletonCard, SkeletonRow, SkeletonTable, SkeletonList, SkeletonGrid, SkeletonFeed };
